import React from "react";
import TableCell from "./TableCell";

const DEFAULT_COLUMNS = (translate = (k) => k) => [
  {
    id: "sequence",
    headLabel: "Sec",
    getCellId: (index) => `RowSequenceSequence${index}`,
    getValue: (row) => row.sequence,
  },
  {
    id: "error",
    type: "checkbox",
    headLabel: translate("error"),
    getCellId: (index) => `RowSequenceError${index}`,
    getValue: (row) => row.error,
  },
  {
    id: "stimulus",
    headLabel: translate("estimulo"),
    getCellId: (index) => `RowSequenceStimul${index}`,
    getValue: (row) => row.estimulo,
  },
  {
    id: "decisionMaking",
    headLabel: "DM",
    tooltipKey: translate("decision-making"),
    getCellId: (index) => `RowSequenceDecisionMaking${index}`,
    getValue: (row) => row.decisionMaking,
    status: true,
  },
  {
    id: "arrival",
    headLabel: translate("arrival"),
    getCellId: (index) => `RowSequenceArrival${index}`,
    getValue: (row) => row.arrival,
    status: true,
  },
  {
    id: "visuMotor",
    headLabel: "VC",
    tooltipKey: translate("velocidad_cognitiva"),
    getCellId: (index) => `RowSequenceVisuMotor${index}`,
    getValue: (row) => row.visuMotor,
  },
  {
    id: "motor",
    headLabel: "VM",
    tooltipKey: translate("velocidad_motriz"),
    getCellId: (index) => `RowSequenceMotor${index}`,
    getValue: (row) => row.motor,
  },
  {
    id: "cognitiveMotor",
    headLabel: "VCM",
    tooltipKey: translate("velocidad_cognitiva_motriz"),
    getCellId: (index) => `RowSequenceCognitiveMotor${index}`,
    getValue: (row) => row.cognitiveMotor,
  },
];

const COLUMN_WIDTHS = {
  sequence: "8%",
  error: "10%",
};
const DEFAULT_COLUMN_WIDTH = "13.67%";

const widthForColumn = (columnId) =>
  COLUMN_WIDTHS[columnId] || DEFAULT_COLUMN_WIDTH;

const defaultStatusClass = (row, columnId) => {
  if (columnId !== "decisionMaking" && columnId !== "arrival") return "";
  if (row.autoComplete) return "text-info-fg";
  return parseInt(row[columnId], 10) === 0 ? "text-warning" : "text-success-fg";
};

function DataTable({
  columns,
  rows = [],
  selectedRowIndex = null,
  onRowSelect,
  onCheckboxChange,
  onCellClick,
  translate = (k) => k,
  statusClass = defaultStatusClass,
  wrapperClassName = "",
  cellClassName = "py-1",
}) {
  const resolvedColumns = columns || DEFAULT_COLUMNS(translate);

  return (
    <div className={`flex h-full min-h-0 w-full flex-col overflow-hidden rounded-sm ${wrapperClassName}`}>
      <div className="table-containerA relative min-h-0 w-full max-h-full flex-1 overflow-y-auto rounded-sm text-center">
        <table className="w-full table-fixed border-collapse">
          <colgroup>
            {resolvedColumns.map((column) => (
              <col key={column.id} style={{ width: widthForColumn(column.id) }} />
            ))}
          </colgroup>
          <thead className="sticky top-0 z-10">
            <tr>
              {resolvedColumns.map((column) => (
                <th
                  key={column.id}
                  scope="col"
                  className="px-2 py-2 bg-control-bg text-sm font-semibold text-secondary"
                  data-tooltip={column.tooltipKey}
                >
                  {column.headLabel}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="scrollable-body">
            {rows.map((row, index) => {
              const isSelected = index === selectedRowIndex;
              const rowClass = isSelected
                ? "bg-brand-accent-faded text-primary font-semibold"
                : "bg-surface text-primary";
              return (
                <tr id={`RowSequenceIndex${index}`} key={index} className={rowClass}>
                  {resolvedColumns.map((column) => {
                    if (column.type === "checkbox") {
                      return (
                        <TableCell
                          key={column.id}
                          className={`px-2 text-center ${cellClassName}`}
                        >
                          <input
                            type="checkbox"
                            checked={row.error}
                            id={column.getCellId(index)}
                            onChange={() => onCheckboxChange(index)}
                            className="accent-danger-fg cursor-pointer"
                            aria-label={`${column.headLabel} fila ${index + 1}`}
                          />
                        </TableCell>
                      );
                    }
                    return (
                      <TableCell
                        key={column.id}
                        id={column.getCellId(index)}
                        className={`px-2 text-center cursor-pointer ${cellClassName} ${statusClass(
                          row,
                          column.id
                        )}`}
                        onClick={() =>
                          column.id === "sequence"
                            ? onRowSelect && onRowSelect(index, row.playID)
                            : onCellClick && onCellClick(index, column.id, row)
                        }
                      >
                        {column.getValue(row)}
                      </TableCell>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DataTable;